const Content = {
    home: "",
    generatedClientStudies: "Estudios Generados",
    study: "Generacion de estudios",
    clients: "Clientes",
    candidates: "Candidatos",
    visits: "Visitas",
    interviewer: "Entrevistador",
    analyst: "Analistas",
    validations: "Validaciones",
    admin: "Administrador",
    clientStudies: "Mis Estudios",
    analystStudies: "Estudios Asignados",
    analystCompleteStudies: "Estudios Completados",
    interviewerStudies: "Estudios Asignados",
}

export default Content